import Relay from 'react-relay';

export default class DeleteOrganisationOverdueBill extends Relay.Mutation {
    static fragments = {
        user: () => Relay.QL`
            fragment on User { id }
        `,
    };

    getMutation() {
        return Relay.QL`mutation { deleteOrganisationOverdueBill }`;
    }

    getVariables() {
        return { id: this.props.id };
    }

    getFatQuery() {
        return Relay.QL`
          fragment on DeleteOrganisationOverdueBillPayload { ok }
        `;
    }

    getConfigs() {
        return [{ type: 'REQUIRED_CHILDREN', children: [
            Relay.QL`fragment on DeleteOrganisationOverdueBillPayload { ok }`
        ] }];
    }
}


